import { Injectable } from '@angular/core';
import { Goal } from 'src/models/onboarding.model';

@Injectable()
export class GoalsProvider {
  constructor() {}

}
